// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { MdKeyboardArrowDown } from "react-icons/md";
// import pose from "../../Assets/variation/pose.jpg";
// import "./PageSliderBar.css";
// import Title from "antd/es/skeleton/Title";
// import Paragraph from "antd/es/skeleton/Paragraph";
// import axios from "axios";
// import { API_BASE_URL } from "../../Config";

// const PageSliderBar = ({ title, data, sideData }) => {
//   const [openType, setOpenType] = useState(null);
//   const [variationList, setVariationList] = useState([]);
//   const [filteredVariations, setFilteredVariations] = useState(null);
//   const [loading, setLoading] = useState(false);

//   console.log("sidebar data", sideData);

//   const [activeCategory, setActiveCategory] = useState("");
//   const [activeVariationName, setActiveVariationName] = useState("");

//   const toggle = (type) => {
//     setOpenType((prev) => (prev === type ? null : type));
//   };

// /*************  ✨ Windsurf Command ⭐  *************/
// /**

// /*******  f3306dc9-c89a-4b47-96ad-329dcf694744  *******/
//   const fetchVariationsByType = async (type) => {
//     try {
//       setLoading(true);
//       setFilteredVariations(null);

//       const res = await axios.get(
//         `${API_BASE_URL}/makevariations?type=${type}`,
//       );

//       setVariationList(res.data.data || []);
//     } catch (error) {
//       console.error("Error fetching variations", error);
//       setVariationList([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const searchVariation = async (name) => {
//     try {
//       setLoading(true);

//       const res = await axios.get(
//         `${API_BASE_URL}/makevariations/filter?name=${name}`,
//       );

//       setFilteredVariations(res.data.data || []);
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const renderContent = () => {
//     if (!activeCategory && !activeVariationName) {
//       return (
//         <div
//           style={{
//             maxWidth: "1000px",
//             margin: "0 auto",
//             padding: "20px 10px",
//             lineHeight: 1.8,
//             color: "#000",
//             fontSize: 16,
//           }}
//         >
//           <h2
//             style={{
//               textAlign: "center",
//               marginBottom: 24,
//               fontWeight: 600,
//             }}
//           >
//             How to Make Variations
//           </h2>

//           <p>
//             Combining other asanas or mudras with the asanas we are learning
//             creates variations in yoga asanas. Below are just a few of the
//             positions that I know of that help create variations. Please help
//             everyone by sending us your knowledge about yoga variations on our
//             website.
//           </p>

//           <p style={{ marginTop: 12 }}>
//             Those who are new to asanas should practice with the advice and
//             guidance of a yoga teacher.
//           </p>

//           <h3
//             style={{
//               color: "red",
//               marginTop: 30,
//               marginBottom: 10,
//               fontWeight: 600,
//             }}
//           >
//             Important tips:
//           </h3>

//           <p>
//             Not all of the above can be used in one asana. Only the variations
//             that are suitable for that asana can be used.
//           </p>

//           <p style={{ marginTop: 12 }}>
//             <strong>For example:</strong>
//           </p>

//           <ol style={{ marginLeft: 30, marginTop: 8 }}>
//             <li>Pada Garudasana cannot be done in Padmasana.</li>
//             <li>Pada Gomukhasana cannot be done in Padmasana.</li>
//           </ol>

//           <p style={{ marginTop: 12 }}>But</p>

//           <ol style={{ marginLeft: 30, marginTop: 8 }}>
//             <li>Hasta Garudasana can be done in Padmasana.</li>
//             <li>Hasta Gomukhasana can be done in Padmasana.</li>
//           </ol>

//           <p style={{ marginTop: 20 }}>
//             Because Padmasana can be done with the feet, other variations that
//             can be done with the feet cannot be done in it. So variations that
//             can be done with the hands can be done in it. And other variations
//             that are suitable for Padmasana can be tried.
//           </p>

//           <p
//             style={{
//               marginTop: 30,
//               fontWeight: 600,
//               fontSize: 16,
//             }}
//           >
//             Try and send us pictures of new variations and your pictures on our
//             website.
//           </p>
//         </div>
//       );
//     }

//     if (filteredVariations?.length > 0) {
//       const mainTitile = filteredVariations[0].variationName;
//       return (
//         <>
//           <Title level={2} style={{ textAlign: "center", marginBottom: 24 }}>
//             {mainTitile}
//           </Title>

//           <div className="variation_grid">
//             {filteredVariations.map((item, index) => (
//               <div className="variation_card" key={item._id}>
//                 <h3 className="variation_title">
//                   {index + 1}. {item.variationName}
//                 </h3>

//                 <div className="variation_image_wrapper">
//                   <img src={item.variationImage} alt={item.variationName} />
//                 </div>

//                 <p>
//                   <b>Sanskrit:</b> {item.sanskrit}
//                 </p>

//                 <p>
//                   <b>English:</b> {item.english}
//                 </p>

//                 <p>
//                   <b>Example Asanas:</b> {item.exampleAsana}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </>
//       );
//     }

//     return (
//       <>
//         <h3 className="activeCategory">{activeCategory}</h3>

//         {loading ? (
//           <p style={{ textAlign: "center" }}>Loading...</p>
//         ) : variationList.length === 0 ? (
//           <p style={{ textAlign: "center" }}>No variations found</p>
//         ) : (
//           <div className="variation_grid">
//             {variationList.map((item, index) => (
//               <div className="variation_card" key={item._id}>
//                 <h3 className="variation_title">
//                   {index + 1}. {item.variationName}
//                 </h3>

//                 <div className="variation_image_wrapper">
//                   <img src={item.variationImage} alt={item.variationName} />
//                 </div>

//                 <p>
//                   <b>Sanskrit:</b> {item.sanskrit}
//                 </p>
//                 <p>
//                   <b>English:</b> {item.english}
//                 </p>
//                 <p>
//                   <b>Example Asanas:</b> {item.exampleAsana}
//                 </p>
//               </div>
//             ))}
//           </div>
//         )}
//       </>
//     );
//   };

//   return (
//     <div className="pageSlider_wrapper">
//       <div
//         className="pageSlider_main"
//         style={{
//           background: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)),
//           url(${pose}) center / cover no-repeat`,
//         }}
//       >
//         <div className="pageSlider_content">
//           <h3 className="slider_title">{title}</h3>

//           {data &&
//             typeof data === "object" &&
//             Object.entries(data).map(([type, items]) => {
//               const isOpen = openType === type;

//               return (
//                 <div key={type} className="slider_section">
//                   <div
//                     className="slider_header"
//                     onClick={() => {
//                       toggle(type);
//                       setActiveCategory(type);
//                       setActiveVariationName("");
//                       setFilteredVariations(null);
//                       fetchVariationsByType(type);
//                     }}
//                   >
//                     <span>{type}</span>
//                     <motion.span animate={{ rotate: isOpen ? 180 : 0 }}>
//                       <MdKeyboardArrowDown />
//                     </motion.span>
//                   </div>

//                   <AnimatePresence>
//                     {isOpen && (
//                       <motion.ul className="slider_list">
//                         {sideData
//                           .filter((asanaType) =>
//                             items.some((item) => item.asanaType === asanaType),
//                           )
//                           .map((asanaType) => (
//                             <li
//                               key={asanaType}
//                               className={`active_item ${
//                                 activeVariationName === asanaType
//                                   ? "active"
//                                   : ""
//                               }`}
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 setActiveVariationName(asanaType);
//                                 searchVariation(asanaType);
//                               }}
//                             >
//                               {asanaType}
//                             </li>
//                           ))}
//                       </motion.ul>
//                     )}
//                   </AnimatePresence>
//                 </div>
//               );
//             })}

//           <div
//             className="slider_header main_menu"
//             onClick={() => {
//               setActiveCategory("");
//               setActiveVariationName("");
//               setFilteredVariations(null);
//               setVariationList([]);
//               setOpenType(null);
//             }}
//           >
//             Main menu
//           </div>
//         </div>
//       </div>

//       <div className="page_main_content">{renderContent()}</div>
//     </div>
//   );
// };

// export default PageSliderBar;

// import React, { useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { MdKeyboardArrowDown } from "react-icons/md";
// import pose from "../../Assets/variation/pose.jpg";
// import "./PageSliderBar.css";
// import Title from "antd/es/skeleton/Title";
// import Paragraph from "antd/es/skeleton/Paragraph";
// import axios from "axios";
// import { API_BASE_URL } from "../../Config";

// const PageSliderBar = ({ title, data, sideData }) => {
//   const [openType, setOpenType] = useState(null);
//   const [variationList, setVariationList] = useState([]);
//   const [filteredVariations, setFilteredVariations] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [activeCategory, setActiveCategory] = useState("");
//   const [activeVariationName, setActiveVariationName] = useState("");

//   const toggle = (type) => {
//     setOpenType((prev) => (prev === type ? null : type));
//   };

//   const fetchVariationsByType = async (type) => {
//     try {
//       setLoading(true);
//       setFilteredVariations(null);

//       const res = await axios.get(
//         `${API_BASE_URL}/makevariations?type=${encodeURIComponent(type)}`,
//       );

//       setVariationList(res.data.data || []);
//     } catch (error) {
//       console.error("Error fetching variations", error);
//       setVariationList([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ── FIXED: now uses fetchVariationsByType with asanaType value ───────
//   // Previously called /filter?name= which searched variationName (wrong)
//   // Now calls /makevariations?type= which matches asanaType (correct)
//   const handlePoseClick = async (asanaType) => {
//     try {
//       setLoading(true);
//       setFilteredVariations(null);

//       const res = await axios.get(
//         `${API_BASE_URL}/makevariations?type=${encodeURIComponent(asanaType)}`,
//       );

//       setFilteredVariations(res.data.data || []);
//     } catch (error) {
//       console.error(error);
//       setFilteredVariations([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const renderContent = () => {
//     if (!activeCategory && !activeVariationName) {
//       return (
//         <div
//           style={{
//             maxWidth: "1000px",
//             margin: "0 auto",
//             padding: "20px 10px",
//             lineHeight: 1.8,
//             color: "#000",
//             fontSize: 16,
//           }}
//         >
//           <h2
//             style={{
//               textAlign: "center",
//               marginBottom: 24,
//               fontWeight: 600,
//             }}
//           >
//             How to Make Variations
//           </h2>

//           <p>
//             Combining other asanas or mudras with the asanas we are learning
//             creates variations in yoga asanas. Below are just a few of the
//             positions that I know of that help create variations. Please help
//             everyone by sending us your knowledge about yoga variations on our
//             website.
//           </p>

//           <p style={{ marginTop: 12 }}>
//             Those who are new to asanas should practice with the advice and
//             guidance of a yoga teacher.
//           </p>

//           <h3
//             style={{
//               color: "red",
//               marginTop: 30,
//               marginBottom: 10,
//               fontWeight: 600,
//             }}
//           >
//             Important tips:
//           </h3>

//           <p>
//             Not all of the above can be used in one asana. Only the variations
//             that are suitable for that asana can be used.
//           </p>

//           <p style={{ marginTop: 12 }}>
//             <strong>For example:</strong>
//           </p>

//           <ol style={{ marginLeft: 30, marginTop: 8 }}>
//             <li>Pada Garudasana cannot be done in Padmasana.</li>
//             <li>Pada Gomukhasana cannot be done in Padmasana.</li>
//           </ol>

//           <p style={{ marginTop: 12 }}>But</p>

//           <ol style={{ marginLeft: 30, marginTop: 8 }}>
//             <li>Hasta Garudasana can be done in Padmasana.</li>
//             <li>Hasta Gomukhasana can be done in Padmasana.</li>
//           </ol>

//           <p style={{ marginTop: 20 }}>
//             Because Padmasana can be done with the feet, other variations that
//             can be done with the feet cannot be done in it. So variations that
//             can be done with the hands can be done in it. And other variations
//             that are suitable for Padmasana can be tried.
//           </p>

//           <p
//             style={{
//               marginTop: 30,
//               fontWeight: 600,
//               fontSize: 16,
//             }}
//           >
//             Try and send us pictures of new variations and your pictures on our
//             website.
//           </p>
//         </div>
//       );
//     }

//     if (filteredVariations?.length > 0) {
//       const mainTitile = filteredVariations[0].asanaType || filteredVariations[0].variationName;
//       return (
//         <>
//           <Title level={2} style={{ textAlign: "center", marginBottom: 24 }}>
//             {mainTitile}
//           </Title>

//           <div className="variation_grid">
//             {filteredVariations.map((item, index) => (
//               <div className="variation_card" key={item._id}>
//                 <h3 className="variation_title">
//                   {index + 1}. {item.variationName}
//                 </h3>

//                 <div className="variation_image_wrapper">
//                   <img src={item.variationImage} alt={item.variationName} />
//                 </div>

//                 <p>
//                   <b>Sanskrit:</b> {item.sanskrit}
//                 </p>

//                 <p>
//                   <b>English:</b> {item.english}
//                 </p>

//                 <p>
//                   <b>Example Asanas:</b> {item.exampleAsana}
//                 </p>
//               </div>
//             ))}
//           </div>
//         </>
//       );
//     }

//     return (
//       <>
//         <h3 className="activeCategory">{activeCategory}</h3>

//         {loading ? (
//           <p style={{ textAlign: "center" }}>Loading...</p>
//         ) : variationList.length === 0 ? (
//           <p style={{ textAlign: "center" }}>No variations found</p>
//         ) : (
//           <div className="variation_grid">
//             {variationList.map((item, index) => (
//               <div className="variation_card" key={item._id}>
//                 <h3 className="variation_title">
//                   {index + 1}. {item.variationName}
//                 </h3>

//                 <div className="variation_image_wrapper">
//                   <img src={item.variationImage} alt={item.variationName} />
//                 </div>

//                 <p>
//                   <b>Sanskrit:</b> {item.sanskrit}
//                 </p>
//                 <p>
//                   <b>English:</b> {item.english}
//                 </p>
//                 <p>
//                   <b>Example Asanas:</b> {item.exampleAsana}
//                 </p>
//               </div>
//             ))}
//           </div>
//         )}
//       </>
//     );
//   };

//   return (
//     <div className="pageSlider_wrapper">
//       <div
//         className="pageSlider_main"
//         style={{
//           background: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)),
//           url(${pose}) center / cover no-repeat`,
//         }}
//       >
//         <div className="pageSlider_content">
//           <h3 className="slider_title">{title}</h3>

//           {data &&
//             typeof data === "object" &&
//             Object.entries(data).map(([type, items]) => {
//               const isOpen = openType === type;

//               return (
//                 <div key={type} className="slider_section">
//                   <div
//                     className="slider_header"
//                     onClick={() => {
//                       toggle(type);
//                       setActiveCategory(type);
//                       setActiveVariationName("");
//                       setFilteredVariations(null);
//                       fetchVariationsByType(type);
//                     }}
//                   >
//                     <span>{type}</span>
//                     <motion.span animate={{ rotate: isOpen ? 180 : 0 }}>
//                       <MdKeyboardArrowDown />
//                     </motion.span>
//                   </div>

//                   <AnimatePresence>
//                     {isOpen && (
//                       <motion.ul className="slider_list">
//                         {sideData
//                           .filter((asanaType) =>
//                             items.some((item) => item.asanaType === asanaType),
//                           )
//                           .map((asanaType) => (
//                             <li
//                               key={asanaType}
//                               className={`active_item ${
//                                 activeVariationName === asanaType ? "active" : ""
//                               }`}
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 setActiveVariationName(asanaType);
//                                 handlePoseClick(asanaType); // ← FIXED: was searchVariation
//                               }}
//                             >
//                               {asanaType}
//                             </li>
//                           ))}
//                       </motion.ul>
//                     )}
//                   </AnimatePresence>
//                 </div>
//               );
//             })}

//           <div
//             className="slider_header main_menu"
//             onClick={() => {
//               setActiveCategory("");
//               setActiveVariationName("");
//               setFilteredVariations(null);
//               setVariationList([]);
//               setOpenType(null);
//             }}
//           >
//             Main menu
//           </div>
//         </div>
//       </div>

//       <div className="page_main_content">{renderContent()}</div>
//     </div>
//   );
// };

// export default PageSliderBar;

import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MdKeyboardArrowDown } from "react-icons/md";
import pose from "../../Assets/variation/pose.jpg";
import "./PageSliderBar.css";
import Title from "antd/es/skeleton/Title";
import axios from "axios";
import { API_BASE_URL } from "../../Config";

const PageSliderBar = ({ title, data, sideData }) => {
  const [openType, setOpenType] = useState(null);
  const [variationList, setVariationList] = useState([]);
  const [filteredVariations, setFilteredVariations] = useState(null);
  const [loading, setLoading] = useState(false);

  const [activeCategory, setActiveCategory] = useState("");
  const [activeVariationName, setActiveVariationName] = useState("");

  const toggle = (type) => {
    setOpenType((prev) => (prev === type ? null : type));
  };

  // ✅ Heading clicked → ONE random card per subheading (asanaType)
  const fetchVariationsByType = async (type) => {
    try {
      setLoading(true);
      setFilteredVariations(null);

      const res = await axios.get(
        `${API_BASE_URL}/makevariations?type=${encodeURIComponent(type)}`,
      );

      const allVariations = res.data.data || [];

      // Group by asanaType (subheading/pose)
      const grouped = {};
      allVariations.forEach((item) => {
        const key = item.asanaType || "Other";
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(item);
      });

      // Pick ONE random card from each subheading
      const randomCards = Object.values(grouped).map((items) => {
        const randomIndex = Math.floor(Math.random() * items.length);
        return items[randomIndex];
      });

      setVariationList(randomCards);
    } catch (error) {
      console.error("Error fetching variations", error);
      setVariationList([]);
    } finally {
      setLoading(false);
    }
  };

  // Pose/subheading clicked → show ALL cards for that pose
  const handlePoseClick = async (asanaType) => {
    try {
      setLoading(true);
      setFilteredVariations(null);

      const res = await axios.get(
        `${API_BASE_URL}/makevariations?type=${encodeURIComponent(asanaType)}`,
      );

      setFilteredVariations(res.data.data || []);
    } catch (error) {
      console.error(error);
      setFilteredVariations([]);
    } finally {
      setLoading(false);
    }
  };

  const renderContent = () => {
    if (!activeCategory && !activeVariationName) {
      return (
        <div
          style={{
            maxWidth: "1000px",
            margin: "0 auto",
            padding: "20px 10px",
            lineHeight: 1.8,
            color: "#000",
            fontSize: 16,
          }}
        >
          <h2 style={{ textAlign: "center", marginBottom: 24, fontWeight: 600 }}>
            How to Make Variations
          </h2>

          <p>
            Combining other asanas or mudras with the asanas we are learning
            creates variations in yoga asanas. Below are just a few of the
            positions that I know of that help create variations. Please help
            everyone by sending us your knowledge about yoga variations on our
            website.
          </p>

          <p style={{ marginTop: 12 }}>
            Those who are new to asanas should practice with the advice and
            guidance of a yoga teacher.
          </p>

          <h3 style={{ color: "red", marginTop: 30, marginBottom: 10, fontWeight: 600 }}>
            Important tips:
          </h3>

          <p>
            Not all of the above can be used in one asana. Only the variations
            that are suitable for that asana can be used.
          </p>

          <p style={{ marginTop: 12 }}>
            <strong>For example:</strong>
          </p>

          <ol style={{ marginLeft: 30, marginTop: 8 }}>
            <li>Pada Garudasana cannot be done in Padmasana.</li>
            <li>Pada Gomukhasana cannot be done in Padmasana.</li>
          </ol>

          <p style={{ marginTop: 12 }}>But</p>

          <ol style={{ marginLeft: 30, marginTop: 8 }}>
            <li>Hasta Garudasana can be done in Padmasana.</li>
            <li>Hasta Gomukhasana can be done in Padmasana.</li>
          </ol>

          <p style={{ marginTop: 20 }}>
            Because Padmasana can be done with the feet, other variations that
            can be done with the feet cannot be done in it. So variations that
            can be done with the hands can be done in it. And other variations
            that are suitable for Padmasana can be tried.
          </p>

          <p style={{ marginTop: 30, fontWeight: 600, fontSize: 16 }}>
            Try and send us pictures of new variations and your pictures on our
            website.
          </p>
        </div>
      );
    }

    // Pose/subheading clicked → show ALL cards for that pose
    if (filteredVariations?.length > 0) {
      const mainTitle =
        filteredVariations[0].asanaType || filteredVariations[0].variationName;
      return (
        <>
          <Title level={2} style={{ textAlign: "center", marginBottom: 24 }}>
            {mainTitle}
          </Title>

          <div className="variation_grid">
            {filteredVariations.map((item) => (
              <div className="variation_card" key={item._id}>
                <h3 className="variation_title">{item.variationName}</h3>
                <div className="variation_image_wrapper">
                  <img src={item.variationImage} alt={item.variationName} />
                </div>
                <p><b>Sanskrit:</b> {item.sanskrit}</p>
                <p><b>English:</b> {item.english}</p>
                <p><b>Example Asanas:</b> {item.exampleAsana}</p>
              </div>
            ))}
          </div>
        </>
      );
    }

    // Heading clicked → ONE random card per subheading
    return (
      <>
        <h3 className="activeCategory">{activeCategory}</h3>

        {loading ? (
          <p style={{ textAlign: "center" }}>Loading...</p>
        ) : variationList.length === 0 ? (
          <p style={{ textAlign: "center" }}>No variations found</p>
        ) : (
          <div className="variation_grid">
            {variationList.map((item) => (
              <div className="variation_card" key={item._id}>
                {/* Shows pose name (asanaType) as card title */}
                <h3 className="variation_title">{item.asanaType}</h3>
                <div className="variation_image_wrapper">
                  <img src={item.variationImage} alt={item.variationName} />
                </div>
                <p><b>Sanskrit:</b> {item.sanskrit}</p>
                <p><b>English:</b> {item.english}</p>
                <p><b>Example Asanas:</b> {item.exampleAsana}</p>
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  return (
    <div className="pageSlider_wrapper">
      <div
        className="pageSlider_main"
        style={{
          background: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)),
          url(${pose}) center / cover no-repeat`,
        }}
      >
        <div className="pageSlider_content">
          <h3 className="slider_title">{title}</h3>

          {data &&
            typeof data === "object" &&
            Object.entries(data).map(([type, items]) => {
              const isOpen = openType === type;

              return (
                <div key={type} className="slider_section">
                  <div
                    className="slider_header"
                    onClick={() => {
                      toggle(type);
                      setActiveCategory(type);
                      setActiveVariationName("");
                      setFilteredVariations(null);
                      fetchVariationsByType(type);
                    }}
                  >
                    <span>{type}</span>
                    <motion.span animate={{ rotate: isOpen ? 180 : 0 }}>
                      <MdKeyboardArrowDown />
                    </motion.span>
                  </div>

                  <AnimatePresence>
                    {isOpen && (
                      <motion.ul className="slider_list">
                        {sideData
                          .filter((asanaType) =>
                            items.some((item) => item.asanaType === asanaType),
                          )
                          .map((asanaType) => (
                            <li
                              key={asanaType}
                              className={`active_item ${
                                activeVariationName === asanaType ? "active" : ""
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                setActiveVariationName(asanaType);
                                handlePoseClick(asanaType);
                              }}
                            >
                              {asanaType}
                            </li>
                          ))}
                      </motion.ul>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}

          <div
            className="slider_header main_menu"
            onClick={() => {
              setActiveCategory("");
              setActiveVariationName("");
              setFilteredVariations(null);
              setVariationList([]);
              setOpenType(null);
            }}
          >
            Main menu
          </div>
        </div>
      </div>

      <div className="page_main_content">{renderContent()}</div>
    </div>
  );
};

export default PageSliderBar;